// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Z0nhe","col":"CardReaderDesc_col__2_DcM","label":"CardReaderDesc_label__FnnL0"};